// Placeholder briefcase icon (~45x35) for CRM classic Ultimate custom-price row.
// TODO: replace with the exported asset from Figma (CRM-pricing-2025-2026 node 5046:61178, Group 1591).
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const UltimateBriefcaseSvg = ()=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "45",
        height: "35",
        viewBox: "0 0 45 35",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "6.5",
                y: "11.5",
                width: "32",
                height: "20",
                rx: "3",
                stroke: "#323338",
                strokeWidth: "1.6"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M17 11.5V9.5C17 8.11929 18.1193 7 19.5 7H25.5C26.8807 7 28 8.11929 28 9.5V11.5",
                stroke: "#323338",
                strokeWidth: "1.6",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.5 19.5H38.5",
                stroke: "#323338",
                strokeWidth: "1.6",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("rect", {
                x: "20",
                y: "17.5",
                width: "5",
                height: "4",
                rx: "1",
                stroke: "#323338",
                strokeWidth: "1.6"
            })
        ]
    });
export default UltimateBriefcaseSvg;
